import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CTAList from './DashboardCTAs/CTAList'
import CTA from './DashboardCTAs/CTA';

function CallToActionRouter() {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/:callToActionId`}>
                <CTA />
            </Route>
            <Route default>
                <CTAList />
            </Route>
        </Switch>
    );
};

export default CallToActionRouter;
